import { ROOT_SLICE } from './constants';

export const selectRootSlice = stateAdmin => stateAdmin[ROOT_SLICE];

export const selectDevFeaturesEnabled = stateAdmin => {
	const slice = selectRootSlice(stateAdmin);
	const { devFeaturesEnabled } = slice;
	return devFeaturesEnabled;
};

export const selectShowDisabledUsers = stateAdmin => {
	const slice = selectRootSlice(stateAdmin);
	const { showDisabledUsers } = slice;
	return showDisabledUsers;
};
